export const titles = {
  defaultTitle: 'Autoleap',
  laborSalesSummary: 'Labor report',
  discountSummary: 'Discount Report',
  releaseNotes: 'AutoLeap - Release notes',
  dashboard: 'Dashboard',
  workboard: 'Workboard',
  workboardList: 'Workboard - List',
  calendar: 'Calendar',
  parts: 'Parts',
  reports: 'Reports',
  customerList: 'Customers - List',
  tenantList: 'Tenants - List',
  shopList: 'Shop - List',
  stockList: 'Stock - List',
  purchaseOrderList: 'Purchase order - List',
  onlineOrderList: 'Online order - List',
  transferOrderList: 'Transfer order - List',
  estimateList: 'Estimates - List',
  deferredList: 'Deferred services - List',
  purchaseOrder: 'Purchase Order',
  partsReturnList: 'Parts return - List',
  partList: 'Parts - List',
  cannedServicesList: 'Canned services - List',
  paymentList: 'Payments - List',
  statementList: 'Statements List',
  tireStorageList: 'Tire storage - List',
  locationList: 'Location - List',
  coreList: 'Core - List',
  laborList: 'Labor - List',
  feesList: 'Fees - List',
  discountsList: 'Discounts - List',
  flatRateList: 'Flat Rate - List',
  tireList: 'Tires - List',
  supplierList: 'Supplier - List',
  warrantiesList: 'Warranties - List',
  inspectionList: 'Inspections - List',
  categoriesList: 'Categories - List',
  salesCodesList: 'Sales Codes - List',
  cannedInspectionList: 'Inspection checklist - List',
  summaryReviews: 'Summary - Reviews',
  settingsReviews: 'Settings - Reviews',
  generalSettings: 'General - Settings',
  userSettings: 'Users - Settings',
  templateSettings: 'Templates - Settings',
  templateAnnouncement: 'Templates - Announcement',
  templateProduct: 'Templates - Product',
  pricingSettings: 'Pricing - Settings',
  reportsSalesReports: 'Report - Sales',
  reportsCannedService: 'Report - Services Invoiced',
  reportsCannedDetailService: 'Report - Canned service detail',
  reportsOutstandInvoice: 'Report - Outstanding invoice',
  dailyReports: 'Report - Daily Payments Report',
  reportsOrderByCutomer: 'Report - Customer aging',
  accountExport: 'Autoleap Export',
  reportsOrderArMovement: 'Report - AR movement',
  reportsOrderApMovement: 'Report - AP movement',
  royalty: 'Royalty Report',
  reportsAllPayments: 'Report - All Payments',
  inventoryActivity: 'Report - Inventory Activity',
  inventoryLevel: 'Report - Inventory Levels',
  unusedInventory: 'Report - Unused inventory',
  warrantiesReport: 'Report - Warranty Report',
  reportsTechnicianSummary: 'Report - Technician summary',
  reportsTechnicianDetails: 'Report - Technician details',
  reportsTechnicianSummaryAllService: 'Technician summary by / All Services',
  reportsTechnicianActivity: 'Report - Technician activity log',
  reportsOrders: 'Report - Orders',
  reportsCustomers: 'Report - Customers',
  reportsGoogleReview: 'Report - Google review',
  reportsInternalSurvey: 'Report - Internal survey',
  reportsTaxSummary: 'Report - Tax summary',
  reportsTaxBreakdownItems: 'Report - Breakdown by items ',
  reportsProfitability: 'Report - Profitability',
  reportsAttendanceLog: 'Report - Attendance Log',
  reportsAttendanceLogDetails: 'Report - Attendance Log',
  marketing: 'Marketing',
  followupCampaign: 'Follow-up campaign',
  followupCampaignList: 'Follow-up campaign - List',
  scheduledFollowups: 'Scheduled Follow-ups - List',
  inventory: 'Inventory',
  campaigns: 'Campaigns',
  campaignsList: 'Promotions - List',
  maketingDashboard: 'Marketing - Dashboard',
  templatesList: 'Templates - List',
  groups: 'Groups',
  groupsList: 'Groups - List',
  reportsSupplierSummary: 'Report - Supplier summary',
  reportsSupplierDetails: 'Report - Supplier details',
  taxDetails: 'Tax Summary - line items',
  itemsReportListTitle: 'Items Sold',
  feeReportTitle: 'Fee Summary Report',
  feeDrillDownTitle: 'Fee Drill Down Report',
  reportDrillDownTitle: 'Item Drill Down',
  LaborReportDrillDownTitle: 'LaborItem Drill Down',
  discountDrillDownTitle: 'Discount Drill Down',
  cashDrawer: 'Cash Drawer',
  cashDrawerDetails: 'Cash Drawer Details',
  commissionPlanTitle: 'Report - Commission summary',
  commissionPlanDetails: 'Report - Commission details',
  accPayableBySuppluier: 'Supplier aging',
  businessSummaryReport: 'Business summary',
  customReporting: 'Custom Reporting',
};
